import { HttpClient } from './types';


export const createOrderService = (httpClient: HttpClient) => {
  const getEndpoint = (url: string): string => `/ordenes${url}`;

  return {
    getAllOrders: <TFilter = any, TResponse = any>(filter: TFilter): Promise<TResponse> => {
      if (httpClient.getWithQueryParamsSerializer) {
        return httpClient.getWithQueryParamsSerializer<TResponse>(getEndpoint(''), filter);
      }
      return httpClient.get<TResponse>(getEndpoint(''), { params: filter });
    },

    getOrderById: <TOrder = any>(orderId: string): Promise<TOrder> => {
      return httpClient.get<TOrder>(getEndpoint(`/${orderId}`));
    },

    createOrder: <TCreate = any, TResponse = any>(order: TCreate): Promise<TResponse> => {
      return httpClient.post<TResponse>(getEndpoint(''), order);
    },

    updateOrder: <TUpdate = any, TResponse = any>(orderGuid: string, order: TUpdate): Promise<TResponse> => {
      return httpClient.put<TResponse>(getEndpoint(`/${orderGuid}`), order);
    },

    completeCheckout: <TFinish = any, TResponse = any>(orderGuid: string, order: TFinish): Promise<TResponse> => {
      return httpClient.post<TResponse>(getEndpoint(`/${orderGuid}/checkout`), order);
    },

    getCheckoutResume: <TResume = any>(orderId: string): Promise<TResume> => {
      return httpClient.get<TResume>(getEndpoint(`/${orderId}/checkout-resume`));
    },

    calculate: <TCalculation = any, TResponse = any>(tmpOrder: TCalculation): Promise<TResponse> => {
      return httpClient.post<TResponse>(getEndpoint('/calcular'), tmpOrder);
    },

    revertOrder: (orderGuid: string): Promise<void> => {
      return httpClient.post<void>(getEndpoint(`/${orderGuid}/revertir`), {});
    },
  };
};

